export const EDGE_RADIUS = 16;
export const EDGE_STROKE_WIDTH = 2;
